import { useSelector } from 'react-redux'
import { selectCurrentToken } from "../features/auth/authSlice"
import jwtDecode from 'jwt-decode'

const useAuth = () => {
    const token = useSelector(selectCurrentToken)
    let isTeacher = false
    let isAdmin = false
    let status = "Student"
    let isStudent = true
    if (token) {
        const decoded = jwtDecode(token)
        const { username, roles, name, image, friends } = decoded.UserInfo
        isTeacher = roles.includes('Teacher')
        isAdmin = roles.includes('Admin')
        
        if (isTeacher) status = "Teacher"
        if (isAdmin) status = "Admin"
        isStudent = status === "Student"
        return { username, roles, status, isTeacher, isAdmin , isStudent, name, image, friends }
    }

    return { username: '', roles: [], isTeacher, isAdmin, status, isStudent,name:'', image:'', friends:null }
}
export default useAuth